export default "__VITE_ASSET__BlP00Y86__"